const SENSITIVE_CACHE_NAMES = ["supabase-cache"] as const;

export async function purgeSensitiveBrowserCaches(): Promise<void> {
  if (typeof window === "undefined" || !("caches" in window)) return;

  await Promise.allSettled(
    SENSITIVE_CACHE_NAMES.map((cacheName) => window.caches.delete(cacheName)),
  );
}
